import { environment } from "../../environments/environment";
import { Injectable } from "@angular/core";
import {
  ModalDismissReasons,
  NgbModal,
  NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
import { HttpClient } from "@angular/common/http";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from "@angular/forms";
import Swal from "sweetalert2";
import * as moment from "moment";

@Injectable({
  providedIn: "root",
})
export class UtilityService {
  modalOptions: NgbModalOptions;
  closeResult: string;
  modalRef: any;
  apiUrl: string;
  taxTaxOffices: any;

  constructor(private modalService: NgbModal, private httpClient: HttpClient) {
    this.modalOptions = {
      backdrop: true,
      centered: true,
      backdropClass: "customBackdrop",
      size: "xl",
    };
  }

  showModal(modal) {
    this.modalService.open(modal, this.modalOptions).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  closeAllModals() {
    this.modalService.dismissAll();
  }

  openModal(modal) {
    this.modalRef = this.modalService.open(modal, this.modalOptions);
    this.manageModal(this.modalRef);
    return this.modalRef;
  }

  private manageModal(modalReference) {
    modalReference.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  MustMatch(controlName: string, matchingControlName: string) {
    return (group: FormGroup) => {
      const control = group.controls[controlName];
      const matchingControl = group.controls[matchingControlName];
      if (control.value !== matchingControl.value) {
        return matchingControl.setErrors({ mustMatch: true });
      }
    };
  }

  MustNotEqual(controlName: string, matchingControlName: string) {
    return (group: FormGroup) => {
      const control = group.controls[controlName];
      const matchingControl = group.controls[matchingControlName];
      if (control.value == matchingControl.value) {
        return matchingControl.setErrors({ mustNotEqual: true });
      }
    };
  }

  mustNotEqualNorLessThan(startControlName: string, endControlName: string) {
    return (group: FormGroup) => {
      const startControl = group.controls[startControlName];
      const endControl = group.controls[endControlName];

      if (startControl.value != "") {
        // const dateFormat = "YYYY-MM-DD HH:mm:ss";
        const dateFormat = "YYYY-MM-DD";
        let now = moment(new Date()).format(dateFormat);

        const timeFrom = now + " " + startControl.value;
        const timeTo = now + " " + endControl.value;

        const timeFromMoment = moment(timeFrom);
        const timeToMoment = moment(timeTo);

        let duration = moment.duration(timeToMoment.diff(timeFromMoment));
        let minutes = duration.asMinutes();
        // let hours = duration.asHours();

        if (minutes < 15) {
          return endControl.setErrors({ mustNotEqualNorLessThan: true });
        }
      }
    };
  }

  minRequiredCheckboxNotChecked(minRequired = 1) {
    return (group: FormGroup) => {
      let checked = 0;

      Object.keys(group.controls).forEach((key) => {
        const control = group.controls[key];
        if (control.value === true) {
          checked++;
        }
      });

      if (checked < minRequired) {
        return {
          requireCheckboxToBeChecked: true,
        };
      }

      return null;
    };
  }

  noWhiteSpaceValidator(control: FormControl) {
    const isWhiteSpace = (control.value || "").trim().length === 0;
    const isValid = !isWhiteSpace;
    return isValid ? null : { whitespace: true };
  }

  emailMustNotEqual(email: string) {
    return (control: FormControl) => {
      const isEqual = (control.value || "").trim() == email;
      return isEqual ? { emailMustNotEqual: true } : null;
    };
  }

  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }
}
